module.exports = __webpack_public_path__ + "f7b2a1b2bbaca96270a729a305dc96d0.svg";